import { Select, SelectProps } from "antd";
import { DefaultOptionType } from "antd/lib/select";
import { useMemo } from "react";
import useAuth from "../../hooks/useAuth";

interface Props extends SelectProps {
	value?: string;
	onChange?: (value: string) => void;
	isFilter?: boolean;
	excludeOfficeId?: string;
	showOfficeCode?: boolean;
}
const SelectMyOffice: React.FC<Props> = ({ isFilter, excludeOfficeId, showOfficeCode, ...rest }) => {
	const { officeList, officeIdList } = useAuth();
	const options = useMemo(() => {
		let list = excludeOfficeId ? officeList.filter((office) => office.officeId !== excludeOfficeId) : officeList;

		return [
			isFilter
				? {
						label: "All Office",
						value: officeIdList.join(","),
				  }
				: null,
			...list.map((item) => ({
				value: item.officeId,
				label: showOfficeCode
					? item.officeName + " / " + (item.officeCode?.toUpperCase() ?? item.tempOfficeCode?.toUpperCase())
					: item.officeName,
				className: "no-ellipsis-option",
			})),
		].filter(Boolean) as DefaultOptionType[];
	}, [officeList, officeIdList, isFilter, excludeOfficeId, showOfficeCode]);

	return (
		<Select
			virtual={false}
			placeholder="Select office..."
			options={options}
			{...rest}
		/>
	);
};
export default SelectMyOffice;
